export default "__VITE_ASSET__WKtHiLgx__"